import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme, keyframes } from '@mui/material/styles';
import * as COLORS from '../styles/colors/colors';
export var ROOT_PREFIX = 'EmbersSkeleton';
var rotate = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    width: 0;\n  }\n\n  to {\n    wdith: 100%;\n  }\n"])));
export var skeletonTheme = createTheme({
  components: {
    MuiSkeleton: {
      styleOverrides: {
        root: _defineProperty({
          background: COLORS.PROMETHEAN_NEUTRAL_MID_GREY
        }, "&.".concat(ROOT_PREFIX, "-animation-progress"), {
          animation: "".concat(rotate, " 2s linear infinite")
        })
      }
    }
  }
});